var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLeft = function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-arrow-left_svg__Layer_1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-arrow-left_svg__cls-1{fill:#393d3c}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.69c-5.34 0-9.69-4.35-9.69-9.69S6.66 2.31 12 2.31s9.69 4.35 9.69 9.69-4.35 9.69-9.69 9.69m0-18.48c-4.85 0-8.79 3.94-8.79 8.79s3.94 8.79 8.79 8.79 8.79-3.94 8.79-8.79S16.85 3.21 12 3.21",
    className: "icon-arrow-left_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.56 16.01c-.1 0-.19-.03-.28-.1l-4.55-3.55a.44.44 0 0 1-.17-.35c0-.14.06-.27.17-.35l4.55-3.58c.2-.15.48-.12.63.08s.12.48-.08.63l-4.1 3.22 4.1 3.2c.2.15.23.44.08.63-.09.11-.22.17-.35.17",
    className: "icon-arrow-left_svg__cls-1"
  })));
};
export default SvgIconArrowLeft;